export const CHECKIN_DATE = 'CheckIn_date';
export const CHECKOUT_DATE = 'CheckOut_date';
export const ROOMS_FIELDNAME = 'Rooms';
export const SUBMIT_TEXT = 'Submit';
export const DATE_TEXT = 'Date';
export const ISREQUIRED_TEXT = 'isRequired';
export const ADULTS_TEXT = 'Adults';
export const FORM_TYPE_TO_CHECK_HOTEL = 'TravelPayout-Hotels';